import lowerCase from 'lodash/lowerCase'

function registerGlobalComponents(Vue) {

    const requireComponent = require.context('@/components/global/', true);

    requireComponent.keys().forEach(fileName => {

        const componentConfig = requireComponent(fileName);
        let componentName = fileName.replace('.vue', '');
        componentName = lowerCase(componentName).split(' ').join('-');

        Vue.component(componentName, componentConfig.default || componentConfig)
    });
}

export default registerGlobalComponents;

